// A match's moderation as its players see it (Match.moderation, from the
// server's MatchModeration): when someone asked for a moderator (null when no
// request is open) and every mod who joined the match chat, still in or not.
// See docs/plans/mod-match-chat.md.

function moderatorsOf(match) {
	return match?.moderation?.moderators || [];
}

// The mods in the match chat now.
export function joinedModeratorsOf(match) {
	return moderatorsOf(match).filter((moderator) => moderator.joined);
}

// A request is open and no mod has joined yet.
export function isModeratorRequested(match) {
	return !!match?.moderation?.requested_at && joinedModeratorsOf(match).length === 0;
}

// Whether a player joined the match chat as a moderator, even if they left
// since: their lines stay marked.
export function isMatchModerator(match, playerId) {
	return moderatorsOf(match).some((moderator) => String(moderator.id) === String(playerId));
}

// Whether a chat message was sent by one of the match's moderators. Only match
// chats (ChatMessages with a match) have any.
export function sentByMatchModerator(chatMessages, message) {
	const match = chatMessages?.match;
	if(!match || !message?.player) {
		return false;
	}
	return isMatchModerator(match, message.player.id);
}
